export function showEventModal(e) {
    e.preventDefault();
    const eventModal = e.currentTarget.parentElement.querySelector("dialog");
    var eventModalId = eventModal.id;
    var eventId = eventModalId.split("eModal-")[1];
    updateUrlParameter('eventId', eventId);
    eventModal.showModal();
    const closeBtn = eventModal.querySelector("span.absolute");
    eventModal.scroll({ top: 0 })
    closeBtn.addEventListener("click", () => {eventModal.close();}, { once: true } );
}


function showEventModalFromUrlParameter() {
    // Create a URLSearchParams instance from the current URL query string.
    const urlParams = new URLSearchParams(window.location.search);

    // Retrieve the value of the "eventId" parameter.
    const eventId = urlParams.get('eventId');

    // Check if the eventId parameter exists and is not an empty string.
    if (eventId) {
        // Prepend "eModal-" to the eventId value to form the modal element's ID.
        const modalId = `eModal-${eventId}`;

        // Find the modal element in the document by its ID.
        const modalElement = document.getElementById(modalId);

        if (modalElement) {
            modalElement.showModal();
            const closeBtn = modalElement.querySelector("span.absolute");
            modalElement.scroll({ top: 0 })
            closeBtn.addEventListener("click", () => { modalElement.close(); }, { once: true });
        } else {
            console.warn(`Modal element with id "${modalId}" not found.`);
        }
    } 
}


// Function to add or update the parameter in the current URL
export function updateUrlParameter(paramKey, paramValue) {
    // Create a URL object based on the current page URL
    const url = new URL(window.location.href);

    // Add or update the parameter
    url.searchParams.set(paramKey, paramValue);

    // Update the current URL without reloading the page
    history.pushState(null, '', url.toString());
}

document.addEventListener('DOMContentLoaded', () => {
    if (window.location.pathname === '/events') {
        showEventModalFromUrlParameter();
    }
});
